import React from "react";
import { Autocomplete as MuiAutocomplete, TextField } from "@mui/material";
import { FONT_INTER } from "../../../styles/fonts";

const ACCENT_COLOR = "#185CFB";

// Thin wrapper over @mui/material/Autocomplete (not react-select, per Globo Marca's
// MUI-only convention) for picking one option from a list, e.g. a resource to add to a profile.
const Autocomplete = ({
  options,
  value,
  onChange,
  placeholder = "Selecionar...",
  getOptionLabel = (option) => option?.label ?? "",
  isOptionEqualToValue = (option, selected) => option?.id === selected?.id,
  disabled,
  sx,
}) => (
  <MuiAutocomplete
    options={options}
    value={value}
    onChange={(_event, newValue) => onChange?.(newValue)}
    getOptionLabel={getOptionLabel}
    isOptionEqualToValue={isOptionEqualToValue}
    disabled={disabled}
    sx={{ fontFamily: FONT_INTER, ...sx }}
    renderInput={(params) => (
      <TextField
        {...params}
        placeholder={placeholder}
        variant="outlined"
        size="small"
        sx={{
          fontFamily: FONT_INTER,
          "& .MuiOutlinedInput-root": { fontFamily: FONT_INTER },
          "& .MuiOutlinedInput-notchedOutline": { borderColor: "#E2E2E3" },
          "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#AEB0B2" },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: ACCENT_COLOR,
            borderWidth: "2px",
          },
        }}
      />
    )}
  />
);

export default Autocomplete;
